var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashIconSlideRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C6867",
    d: "M66,1002.2c0-1-0.4-1.9-1.1-2.7l-24-25c-1.5-1.6-4.1-1.6-5.7-0.1c-1.6,1.5-1.6,4.1-0.1,5.7l21.3,22.2 l-21.3,22.2c-1.5,1.6-1.5,4.1,0.1,5.7c1.6,1.5,4.1,1.5,5.7-0.1l24-25C65.6,1004.4,66,1003.3,66,1002.2L66,1002.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashIconSlideRight);
export default __webpack_public_path__ + "static/media/dash_icon_slide_right.50bb51acd2fb54dca84f81642cff3209.svg";
export { ForwardRef as ReactComponent };